import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="container py-8 text-center">
      <h1 className="text-4xl font-bold mb-4">404 - Page Not Found</h1>
      
      <div style={{ fontSize: '6rem', margin: '2rem 0' }}>
        😕
      </div>
      
      <p className="mb-6">
        The page you are looking for does not exist or has been moved.
      </p>
      
      <Link to="/" className="btn btn-primary">
        Return to Home
      </Link>
    </div>
  );
};

export default NotFoundPage; 